import styled, { css } from 'styled-components';
import Box from '../../../_shared/components/Box';
import { StyledThumbnail } from '../ListTradeCard/Styles';
import isOmpPlatform from '../../../_shared/utils/isOmpPlatform';

const contentBottomBorder = css`
  border-bottom: 2px solid ${({ theme }) => theme.COLORS.NEUTRAL_50};
`;

export const StyledPendingThumbnail = styled(StyledThumbnail)`
  width: 144px;
  height: 130px;
  margin: 0;
`;

export const Column = styled(Box.Column)`
  background: ${({ theme }) => theme.COLORS.BASE};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  flex: 1 1 auto;
  max-width: inherit;
`;

export const StyledRow = styled(Box.Row)`
  display: flex;
  ${props => props.showBottomBorder && contentBottomBorder};
`;

export const StyledWrapper = styled(Box)`
  max-width: inherit;
  height: 42px;
  padding: 14px;
  border-top: 2px solid ${({ theme }) => theme.COLORS.NEUTRAL_50};
  border-bottom: 2px solid ${({ theme }) => theme.COLORS.NEUTRAL_50};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  align-items: center;

  ${() =>
    isOmpPlatform() &&
    css`
      border-top: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_110};
      border-bottom: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_110};
    `}
`;

export const StyledActiveListTimer = styled.div`
  background: ${({ theme }) => theme.COLORS.BASE};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  align-self: flex-end;
  padding: 4px 9px;
  border-radius: 3px;
  z-index: 1;
  position: absolute;
  top: 6px;
  left: 6px;
`;
